/**
 * @file lite文档入口
 * @author Wanzhongyun
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import 'element-qsa-scope';
import ReactDOM from 'react-dom';
import DocRoute from './DocRoute';
import 'antd/dist/antd.less';
import 'src/components/document/style/index.scss';

ReactDOM.render(<DocRoute />, document.getElementById('root'));
